export default "__VITE_ASSET__8967fb89__"